var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXirifyPayment1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_3151",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_32_13",
    "data-name": "Component 32 \\u2013 13",
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_29_3",
    "data-name": "Component 29 \\u2013 3"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -3, -2)",
    filter: "url(#Rectangle_3151)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3151-2",
    "data-name": "Rectangle 3151",
    width: 44,
    height: 44,
    rx: 15,
    transform: "translate(3 2)",
    fill: "#15b5d8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33631",
    "data-name": "Group 33631",
    transform: "translate(4.028 8.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33626",
    "data-name": "Group 33626",
    transform: "translate(13.902 9.163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33625",
    "data-name": "Group 33625",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143079",
    "data-name": "Path 143079",
    d: "M174.467,154.594h-1.106a3.464,3.464,0,0,0-.466-1.081h1.572a.831.831,0,1,0,.008-1.663h-6.444a.831.831,0,1,0,0,1.663h1.846a1.887,1.887,0,0,1,1.746,1.081h-3.592a.831.831,0,1,0,0,1.663h3.592a2.608,2.608,0,0,1-.374.524,1.953,1.953,0,0,1-1.364.557H168.04a.845.845,0,0,0-.831.856.858.858,0,0,0,.258.6l4.606,4.365a.829.829,0,1,0,1.164-1.181l-.025-.025-3.1-2.935a3.551,3.551,0,0,0,2.3-1.048,3.515,3.515,0,0,0,.956-1.713h1.1a.831.831,0,1,0,0-1.663Z",
    transform: "translate(-167.2 -151.85)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33628",
    "data-name": "Group 33628",
    transform: "translate(6.437 9.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33627",
    "data-name": "Group 33627",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143080",
    "data-name": "Path 143080",
    d: "M106.725,166.787l-3.825-5.579a.829.829,0,0,0-.682-.357.818.818,0,0,0-.682.357L97.7,166.77a.84.84,0,0,0,.216,1.164.86.86,0,0,0,.466.15h2.785a12.141,12.141,0,0,1-4.357,7.209,12.836,12.836,0,0,1-7.916,2.943,13.113,13.113,0,0,1-9.978-5.064.832.832,0,1,0-1.339.989.115.115,0,0,1,.025.033A14.63,14.63,0,0,0,88.9,179.907a14.481,14.481,0,0,0,8.963-3.318,13.83,13.83,0,0,0,4.989-8.5h3.193a.836.836,0,0,0,.831-.84A.778.778,0,0,0,106.725,166.787Z",
    transform: "translate(-77.417 -160.85)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33630",
    "data-name": "Group 33630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33629",
    "data-name": "Group 33629",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143081",
    "data-name": "Path 143081",
    d: "M29.3,47.4a.115.115,0,0,1-.025-.033A14.63,14.63,0,0,0,17.985,41.65a14.481,14.481,0,0,0-8.963,3.318,13.845,13.845,0,0,0-5,8.506H.831a.836.836,0,0,0-.831.84.778.778,0,0,0,.15.466l3.841,5.563a.829.829,0,0,0,.682.358.818.818,0,0,0,.682-.358l3.833-5.563a.836.836,0,0,0-.69-1.305H5.712a12.141,12.141,0,0,1,4.357-7.209,12.836,12.836,0,0,1,7.916-2.943,13.112,13.112,0,0,1,9.978,5.064A.832.832,0,1,0,29.3,47.4Z",
    transform: "translate(0 -41.65)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXirifyPayment1);
export default __webpack_public_path__ + "static/media/XirifyPayment1.f5766ae1e17cd667f0a30876c14f6c83.svg";
export { ForwardRef as ReactComponent };